import { useEffect, useState } from "react";
import { isSharing, rememberedDriverId, setSharing } from "../location";

/** Pin button: share this phone's location as the remembered driver (opt-in, per phone). */
export default function LocationToggle() {
  const [on, setOn] = useState(isSharing);
  const [busy, setBusy] = useState(false);
  const [hint, setHint] = useState<string | null>(null);

  useEffect(() => {
    const sync = () => setOn(isSharing());
    window.addEventListener("location-sharing", sync);
    return () => window.removeEventListener("location-sharing", sync);
  }, []);

  useEffect(() => {
    if (!hint) return;
    const t = setTimeout(() => setHint(null), 6000);
    return () => clearTimeout(t);
  }, [hint]);

  if (!rememberedDriverId()) return null;

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await setSharing(!on);
      setHint(!on ? "Sharing your location while the app is open." : "Location sharing off.");
    } catch (err) {
      setHint(err instanceof Error ? err.message : "Couldn't change location sharing");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        onClick={toggle}
        disabled={busy}
        aria-label={on ? "Stop sharing location" : "Share location"}
        title={on ? "Sharing location" : "Share location"}
        className={`flex size-10 items-center justify-center rounded-full transition-transform active:scale-95 disabled:opacity-60 ${
          on ? "bg-blush text-rose-ink" : "border border-line bg-white text-ink-soft"
        }`}
      >
        <svg viewBox="0 0 24 24" className="size-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M12 21s-6-5.5-6-11a6 6 0 1 1 12 0c0 5.5-6 11-6 11Z" />
          <circle cx="12" cy="10" r="2.5" />
          {!on && <path d="M4 4l16 16" />}
        </svg>
      </button>
      {hint && (
        <div className="pop-in fixed inset-x-4 top-4 z-50 mx-auto max-w-md rounded-[14px] bg-ink px-4 py-3 text-center text-sm font-semibold text-white shadow-pop">
          {hint}
        </div>
      )}
    </>
  );
}
